<template>
    <div class="feed twitter-feed">
        <div class="row">
            <div class="col-md-4" v-for="item in feed" :key="item.id" :class="itemClass(item)" @click="toggle(item)">
                <div class="feed-item twitter-item">
                    {{ item.text }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import FeedMixin from './FeedMixin';
    export default {
        name: 'TwitterFeed',
        mixins: [FeedMixin]
    }
</script>